// services/storage.service.js

const STORAGE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  SESSION_ID: 'sessionId',
  ACCESS_EXPIRES: 'accessTokenExpires',
  REFRESH_EXPIRES: 'refreshTokenExpires',
  EULA_FIRMED: 'eulaFirmed',
  CREDENTIALS_IDENTIFICADOR: 'credentialsidentificador',
  CREDENTIALS_PASS: 'credentialspass',
  USER_FULLNAME: 'fullName',
  DATA_HOUR_GRAPH: 'dataHourGraph',
  // Settings
  DAILY_SEC: 'dailySec',
  WORKERS_SEC: 'workersSec',
  ORGANISMOS_SEC: 'organismosSec',
  HOUR_GRAPH_SEC: 'hourGraphSec',
  TOP_VENTAS_SEC: 'topVentasSec',
  TOP_RECEP_SEC: 'topRecepSec',
  RESUME_INVENTORY_SEC: 'resumeInventorySec',
  TEAMS_SEC: 'teamSec'
};

export const storageService = {

    setSettings(dailySec,workersSec,organismosSec,hourGraphSec,topVentasSec,topRecepSec,resumeInventorySec,teamSec){
        localStorage.setItem(STORAGE_KEYS.DAILY_SEC,dailySec)
        localStorage.setItem(STORAGE_KEYS.WORKERS_SEC,workersSec)
        localStorage.setItem(STORAGE_KEYS.ORGANISMOS_SEC,organismosSec)
        localStorage.setItem(STORAGE_KEYS.HOUR_GRAPH_SEC,hourGraphSec)
        localStorage.setItem(STORAGE_KEYS.TOP_VENTAS_SEC,topVentasSec)
        localStorage.setItem(STORAGE_KEYS.TOP_RECEP_SEC,topRecepSec)
        localStorage.setItem(STORAGE_KEYS.RESUME_INVENTORY_SEC,resumeInventorySec)
        localStorage.setItem(STORAGE_KEYS.TEAMS_SEC,teamSec)
    },

    getSettings() {
        const getBool = (key, defaultValue = true) => {
            const stored = localStorage.getItem(key);
            console.log(`Key: ${key}, Stored: ${stored}, Type: ${typeof stored}`);
            return stored === null ? defaultValue : stored === 'true';
        };

        return {
            dailySec: getBool(STORAGE_KEYS.DAILY_SEC),
            workersSec: getBool(STORAGE_KEYS.WORKERS_SEC),
            organismosSec: getBool(STORAGE_KEYS.ORGANISMOS_SEC),
            hourGraphSec: getBool(STORAGE_KEYS.HOUR_GRAPH_SEC),
            topVentasSec: getBool(STORAGE_KEYS.TOP_VENTAS_SEC),
            topRecepSec: getBool(STORAGE_KEYS.TOP_RECEP_SEC),
            resumeInventorySec: getBool(STORAGE_KEYS.RESUME_INVENTORY_SEC),
            teamSec: getBool(STORAGE_KEYS.TEAMS_SEC),
        };
    },
  // Tokens persistentes (localStorage)
    setTokens({ accessToken, refreshToken, accessTokenExpires, refreshTokenExpires }) {
        localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
        localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
        localStorage.setItem(STORAGE_KEYS.ACCESS_EXPIRES, accessTokenExpires);
        localStorage.setItem(STORAGE_KEYS.REFRESH_EXPIRES, refreshTokenExpires);
    },

    setSession(sessionId) {
        localStorage.setItem(STORAGE_KEYS.SESSION_ID, sessionId);
    },

    getSession(){
        return localStorage.getItem(STORAGE_KEYS.SESSION_ID)
    },

    // ⚡ CREDENCIALES SENSIBLES - sessionStorage (se borra al cerrar pestaña)
    setCredentials(identifier, password) {
        sessionStorage.setItem(STORAGE_KEYS.CREDENTIALS_IDENTIFICADOR, identifier);
        sessionStorage.setItem(STORAGE_KEYS.CREDENTIALS_PASS, password);
    },

    setUserData(fullname) {
        localStorage.setItem(STORAGE_KEYS.USER_FULLNAME,fullname)
    },

    getCredentials() {
        return {
            identifier: sessionStorage.getItem(STORAGE_KEYS.CREDENTIALS_IDENTIFICADOR),
            password: sessionStorage.getItem(STORAGE_KEYS.CREDENTIALS_PASS)
        };
    },

    getUserData() {
        return {
            fullName : localStorage.getItem(STORAGE_KEYS.USER_FULLNAME)
        };
    },

    setGraphHourData(list_data) {
        // ✅ Convertir a JSON string antes de guardar
        sessionStorage.setItem(STORAGE_KEYS.DATA_HOUR_GRAPH, JSON.stringify(list_data));
    },

    getGraphHourData() {
        const data = sessionStorage.getItem(STORAGE_KEYS.DATA_HOUR_GRAPH);
        if (!data) return null;
        
        try {
            // ✅ Parsear de vuelta a array/objeto
            return JSON.parse(data);
        } catch (error) {
            console.error('Error parseando graphHourData:', error);
            return null;
        }
    },

    getGeneralSesionStorage(){
        const rawData = sessionStorage.getItem(STORAGE_KEYS.DATA_HOUR_GRAPH);
        let parsedData = null;
        
        if (rawData) {
            try {
                parsedData = JSON.parse(rawData);
            } catch (e) {
                console.error('Error parseando graph_hour_data:', e);
            }
        }
        return {
            graph_hour_data : parsedData,
            credentials_id : sessionStorage.getItem(STORAGE_KEYS.CREDENTIALS_IDENTIFICADOR),
            credentials_pass : sessionStorage.getItem(STORAGE_KEYS.CREDENTIALS_PASS)
        }
    },

    clearCredentials() {
        sessionStorage.removeItem(STORAGE_KEYS.CREDENTIALS_IDENTIFICADOR);
        sessionStorage.removeItem(STORAGE_KEYS.CREDENTIALS_PASS);
        sessionStorage.removeItem(STORAGE_KEYS.DATA_HOUR_GRAPH);
    },

    setEulaFirmed(value) {
        localStorage.setItem(STORAGE_KEYS.EULA_FIRMED, value.toString());
    },

    getEulaFirmed() {
        console.log("Eula Firmada??:",localStorage.getItem(STORAGE_KEYS.EULA_FIRMED))
        return localStorage.getItem(STORAGE_KEYS.EULA_FIRMED);
    },

    // Obtener todo (útil para restoreSession)
    getAll() {
        return {
        token: localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN),
        refreshToken: localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN),
        sessionId: localStorage.getItem(STORAGE_KEYS.SESSION_ID),
        accessExpires: localStorage.getItem(STORAGE_KEYS.ACCESS_EXPIRES),
        refreshExpires: localStorage.getItem(STORAGE_KEYS.REFRESH_EXPIRES),
        eulaFirmed: localStorage.getItem(STORAGE_KEYS.EULA_FIRMED),
        fullName: localStorage.getItem(STORAGE_KEYS.USER_FULLNAME),
        // Credenciales de sessionStorage
        credentials: this.getCredentials()
        };
    },

    clear() {
        // Limpia localStorage
        Object.values(STORAGE_KEYS).forEach(key => localStorage.removeItem(key));
        // Limpia sessionStorage también
        this.clearCredentials();
    },

    clearSensitive() {
        localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
        localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
        localStorage.removeItem(STORAGE_KEYS.SESSION_ID);
        this.clearCredentials(); // Esto ahora limpia sessionStorage
    }
};